import React from 'react';
import { BufferedRange } from './styled';
const PERCENT = 100;
export const Buffered = ({ playerInstance, className = '', duration, style = null, }) => {
    const bufferedRanges = (playerInstance === null || playerInstance === void 0 ? void 0 : playerInstance.bufferedRanges) || [];
    const result = bufferedRanges.map((buffered) => {
        if (!buffered)
            return null;
        const { start, end } = buffered;
        const fromLeft = (start / duration) * PERCENT;
        const length = (end / duration) * PERCENT - fromLeft;
        return !Number.isNaN(start) && !Number.isNaN(end) ? (React.createElement(BufferedRange, { className: `${className} Buffered`, "data-test": "Buffered-Range", key: `BufferedRange-${start}`, fromLeft, length, style })) : null;
    });
    return React.createElement("div", null, result);
};
//# sourceMappingURL=index.js.map